var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGeneral(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_28648",
    "data-name": "Group 28648",
    transform: "translate(-75 -417)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27132",
    "data-name": "Group 27132",
    transform: "translate(6 -109)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "noun_Settings_4400623",
    transform: "translate(81.031 395.929)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_26_Settings",
    "data-name": "26 Settings",
    transform: "translate(-0.031 28.07)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_45443",
    "data-name": "Path 45443",
    d: "M.994,33.683H2.2a4.588,4.588,0,0,0,8.944,0h8.787a1.025,1.025,0,1,0,0-2.049H11.144a4.588,4.588,0,0,0-8.944,0H.994a1.025,1.025,0,1,0,0,2.049ZM6.671,30.12a2.538,2.538,0,1,1-2.538,2.538A2.538,2.538,0,0,1,6.671,30.12Z",
    transform: "translate(0.031 -28.07)",
    fill: "#adadad",
    stroke: "#adadad",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45444",
    "data-name": "Path 45444",
    d: "M19.931,262.505H18.725a4.588,4.588,0,0,0-8.944,0H.994a1.025,1.025,0,1,0,0,2.049H9.781a4.588,4.588,0,0,0,8.944,0h1.206a1.025,1.025,0,1,0,0-2.049Zm-5.678,3.563a2.538,2.538,0,1,1,2.538-2.538A2.538,2.538,0,0,1,14.253,266.068Z",
    transform: "translate(0.031 -249.48)",
    fill: "#adadad",
    stroke: "#adadad",
    strokeWidth: 0.25
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneral);
export default __webpack_public_path__ + "static/media/General.16a2a43d.svg";
export { ForwardRef as ReactComponent };